var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "px-10 my-3", attrs: { fluid: "" } },
    [
      _c(
        "portal",
        { attrs: { to: "page-title" } },
        [
          _c("v-breadcrumbs", {
            attrs: {
              items: [
                { text: _vm.$tc("labels.general", 2), disabled: false },
                { text: _vm.$tc("labels.jobType", 2), disabled: false }
              ]
            },
            scopedSlots: _vm._u([
              {
                key: "divider",
                fn: function() {
                  return [
                    _c("v-icon", { attrs: { size: "8" } }, [
                      _vm._v("\n          far fa-chevron-right\n        ")
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { id: "jobTypes" } },
        [
          _c(
            "v-row",
            { staticClass: "actions", attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                [
                  _c("v-text-field", {
                    staticClass:
                      "name-filter pt-3 pb-1 ml-4 extra-dense-text-field d-inline-block",
                    attrs: {
                      "append-icon": _vm.filters.name ? "" : "fal fa-search",
                      clearable: !!_vm.filters.name,
                      dense: "",
                      "hide-details": "",
                      placeholder: _vm.$t("labels.searchByName"),
                      solo: ""
                    },
                    model: {
                      value: _vm.filters.name,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.filters,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "filters.name"
                    }
                  }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "float-right mt-2 mr-4",
                      attrs: { color: "secondary" },
                      on: {
                        click: function($event) {
                          return _vm.openJobTypeDialog()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("labels.addJobType")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-data-table", {
            directives: [
              {
                name: "resize",
                rawName: "v-resize.quiet",
                value: _vm.onWindowResized,
                expression: "onWindowResized",
                modifiers: { quiet: true }
              }
            ],
            attrs: {
              "fixed-header": "",
              headers: _vm.headers,
              "header-props": { sortIcon: "fa fa-arrow-up" },
              "hide-default-footer": "",
              items: _vm.paginatedJobTypes,
              "items-per-page": _vm.pagination.itemsPerPage,
              "must-sort": "",
              "single-select": "",
              "sort-by": _vm.sort.by,
              "sort-desc": _vm.sort.desc
            },
            on: {
              "update:sortBy": function($event) {
                return _vm.$set(_vm.sort, "by", $event)
              },
              "update:sort-by": function($event) {
                return _vm.$set(_vm.sort, "by", $event)
              },
              "update:sortDesc": function($event) {
                return _vm.$set(_vm.sort, "desc", $event)
              },
              "update:sort-desc": function($event) {
                return _vm.$set(_vm.sort, "desc", $event)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "header.description",
                fn: function(ref) {
                  var header = ref.header
                  return [
                    _c("span", { staticClass: "grey--text text--darken-3" }, [
                      _vm._v(
                        "\n          " + _vm._s(header.text) + "\n        "
                      )
                    ])
                  ]
                }
              },
              {
                key: "header.associatedGroup",
                fn: function(ref) {
                  var header = ref.header
                  return [
                    _c("MultiSelectionList", {
                      attrs: { selection: _vm.groupsAvailable },
                      on: {
                        selectionConfirmed: function($event) {
                          return _vm.setFilter(header.value, $event)
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass:
                                        "ml-n4 subtitle-2 text-capitalize",
                                      attrs: { color: "secondary", text: "" }
                                    },
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(header.text) +
                                        "\n              "
                                    ),
                                    _vm.filters[header.value].length > 0
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              color: "grey",
                                              right: "",
                                              "x-small": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                fas fa-filter\n              "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "v-icon",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              color: "grey",
                                              right: "",
                                              "x-small": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                fal fa-filter\n              "
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ]
                }
              },
              {
                key: "header.associatedShiftTypes",
                fn: function(ref) {
                  var header = ref.header
                  return [
                    _c("MultiSelectionList", {
                      attrs: { selection: _vm.shiftTypesAvailable },
                      on: {
                        selectionConfirmed: function($event) {
                          return _vm.setFilter(header.value, $event)
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass:
                                        "ml-n4 subtitle-2 text-capitalize",
                                      attrs: { color: "secondary", text: "" }
                                    },
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(header.text) +
                                        "\n              "
                                    ),
                                    _vm.filters[header.value].length > 0
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              color: "grey",
                                              right: "",
                                              "x-small": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                fas fa-filter\n              "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "v-icon",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              color: "grey",
                                              right: "",
                                              "x-small": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                fal fa-filter\n              "
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ]
                }
              },
              {
                key: "header.swappableJobTypes",
                fn: function(ref) {
                  var header = ref.header
                  return [
                    _c("MultiSelectionList", {
                      attrs: { selection: _vm.jobTypesAvailable },
                      on: {
                        selectionConfirmed: function($event) {
                          return _vm.setFilter(header.value, $event)
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass:
                                        "ml-n4 subtitle-2 text-capitalize",
                                      attrs: { color: "secondary", text: "" }
                                    },
                                    on
                                  ),
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(header.text) +
                                        "\n              "
                                    ),
                                    _vm.filters[header.value].length > 0
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              color: "grey",
                                              right: "",
                                              "x-small": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                fas fa-filter\n              "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "v-icon",
                                          {
                                            staticClass: "ml-2",
                                            attrs: {
                                              color: "grey",
                                              right: "",
                                              "x-small": ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                fal fa-filter\n              "
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ]
                }
              },
              {
                key: "item",
                fn: function(ref) {
                  var item = ref.item
                  var tableHeaders = ref.headers
                  return [
                    _c(
                      "tr",
                      {
                        class: item.obsolete ? "obsolete" : "",
                        on: {
                          mouseenter: function($event) {
                            _vm.hoveredItem = item
                          },
                          mouseleave: function($event) {
                            _vm.hoveredItem = null
                          }
                        }
                      },
                      [
                        _vm._l(tableHeaders, function(header) {
                          return _c(
                            "td",
                            { key: header.value, staticClass: "text-start" },
                            [
                              header.value === "name"
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "grey--text text--darken-3 text-truncate d-block",
                                      style: { width: header.width + "px" },
                                      attrs: { title: item.name }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.name) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              header.value === "description"
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "grey--text text--darken-3 text-truncate d-block",
                                      style: { width: header.width + "px" },
                                      attrs: { title: item.description }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.description) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              header.value === "associatedGroup"
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "grey--text text--darken-3 text-truncate d-block text-capitalize",
                                      style: { width: header.width + "px" },
                                      attrs: {
                                        title: _vm.getAssociatedGroupDisplay(
                                          item
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getAssociatedGroupDisplay(item)
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              header.value === "associatedShiftTypes"
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "grey--text text--darken-3 text-truncate d-block",
                                      style: { width: header.width + "px" },
                                      attrs: {
                                        title: _vm.getAssociatedShiftTypesDisplay(
                                          item
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getAssociatedShiftTypesDisplay(
                                              item
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              header.value === "swappableJobTypes"
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "grey--text text--darken-3 text-truncate d-block",
                                      style: { width: header.width + "px" },
                                      attrs: {
                                        title: _vm.getSwappableJobTypesDisplay(
                                          item
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getSwappableJobTypesDisplay(
                                              item
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              header.value === "partakeInScheduling"
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "d-inline-block",
                                        style: { "min-width": "140px" }
                                      },
                                      [
                                        item.partakeInScheduling
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "success",
                                                  small: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  fas fa-check-circle\n                "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "grey",
                                                  small: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  far fa-times-circle\n                "
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        }),
                        _c(
                          "v-speed-dial",
                          {
                            staticClass: "mt-6 job-type-dial",
                            attrs: {
                              absolute: "",
                              value:
                                _vm.hoveredItem &&
                                _vm.hoveredItem.id === item.id,
                              right: "",
                              direction: "left",
                              transition: "slide-x-reverse-transition"
                            }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "edit",
                                attrs: {
                                  fab: "",
                                  height: "30",
                                  width: "30",
                                  title: _vm.$t("labels.editJobType")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.openJobTypeDialog(item)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v(
                                    "\n                fal fa-pencil\n              "
                                  )
                                ])
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "delete",
                                attrs: {
                                  fab: "",
                                  height: "30",
                                  width: "30",
                                  title: _vm.$t("labels.deleteJobType")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.openDeleteConfirmationDialog(
                                      item
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { color: "error", small: "" } },
                                  [
                                    _vm._v(
                                      "\n                fal fa-trash-alt\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ]
                }
              },
              {
                key: "footer",
                fn: function() {
                  return [
                    _c("v-pagination", {
                      staticClass: "py-4 footer",
                      attrs: {
                        color: "secondary",
                        length: _vm.numberOfPages,
                        "next-icon": "far fa-chevron-right",
                        "prev-icon": "far fa-chevron-left",
                        "total-visible": _vm.pagination.maxPaginationControls
                      },
                      model: {
                        value: _vm.pagination.currentPage,
                        callback: function($$v) {
                          _vm.$set(_vm.pagination, "currentPage", $$v)
                        },
                        expression: "pagination.currentPage"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm.showJobTypeDialog
        ? _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                width: "500px",
                value: _vm.showJobTypeDialog
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-0", attrs: { id: "jobType" } },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "body-2 d-block mb-2" },
                    [
                      _c("span", { staticClass: "body-2 font-weight-medium" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.selectedJobType.id
                                ? _vm.$t("labels.editJobType")
                                : _vm.$t("labels.addJobType")
                            ) +
                            "\n        "
                        )
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "float-right mt-n1",
                          attrs: { disabled: _vm.saving, icon: "", small: "" },
                          on: { click: _vm.closeJobTypeDialog }
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("\n            fal fa-times\n          ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "px-0" },
                    [
                      _c("ValidationObserver", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var invalid = ref.invalid
                                var passes = ref.passes
                                return [
                                  _c(
                                    "v-form",
                                    { staticClass: "job-type" },
                                    [
                                      _c(
                                        "v-container",
                                        { staticClass: "pt-0 px-6" },
                                        [
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "12", sm: "6" }
                                                },
                                                [
                                                  _c("VeeTextField", {
                                                    attrs: {
                                                      dense: "",
                                                      label: _vm.$t(
                                                        "labels.name"
                                                      ),
                                                      name: "name",
                                                      outlined: "",
                                                      rules: {
                                                        required: true,
                                                        max: 32,
                                                        excluded: _vm.namesInUse
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedJobType
                                                          .name,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobType,
                                                          "name",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobType.name"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "12", sm: "6" }
                                                },
                                                [
                                                  _c("VeeTextField", {
                                                    attrs: {
                                                      dense: "",
                                                      label: _vm.$t(
                                                        "labels.description"
                                                      ),
                                                      name: "description",
                                                      outlined: "",
                                                      rules: "max:256"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedJobType
                                                          .description,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobType,
                                                          "description",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobType.description"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("VeeSelect", {
                                                    attrs: {
                                                      dense: "",
                                                      item: "",
                                                      "item-text": "label",
                                                      "item-value": "value",
                                                      items:
                                                        _vm.groupsAvailable,
                                                      label: _vm.$t(
                                                        "labels.associatedGroup"
                                                      ),
                                                      outlined: "",
                                                      rules: "required"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedJobType
                                                          .settings
                                                          .associatedGroups,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobType
                                                            .settings,
                                                          "associatedGroups",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobType.settings.associatedGroups"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("VeeSelect", {
                                                    attrs: {
                                                      dense: "",
                                                      item: "",
                                                      "item-text": "label",
                                                      "item-value": "value",
                                                      items:
                                                        _vm.shiftTypesAvailable,
                                                      label: _vm.$t(
                                                        "labels.associatedShiftTypes"
                                                      ),
                                                      multiple: "",
                                                      outlined: "",
                                                      rules: "required"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedJobType
                                                          .settings
                                                          .associatedShiftTypes,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobType
                                                            .settings,
                                                          "associatedShiftTypes",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobType.settings.associatedShiftTypes"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("VeeSelect", {
                                                    ref: "swappableJobTypes",
                                                    attrs: {
                                                      dense: "",
                                                      item: "",
                                                      "item-text": "label",
                                                      "item-value": "value",
                                                      items:
                                                        _vm.jobTypesAvailable,
                                                      label: _vm.$t(
                                                        "labels.canSwapWith"
                                                      ),
                                                      "menu-props": {
                                                        top: false,
                                                        offsetY: true
                                                      },
                                                      multiple: "",
                                                      outlined: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedJobType
                                                          .swappableJobTypes,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobType,
                                                          "swappableJobTypes",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobType.swappableJobTypes"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("v-switch", {
                                                    staticClass:
                                                      "pt-0 mt-1 d-inline-block",
                                                    attrs: {
                                                      color: "success",
                                                      dense: "",
                                                      "hide-details": "",
                                                      inset: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function() {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "mr-4 body-2 grey--text text--darken-3",
                                                                  attrs: {
                                                                    title: _vm.$t(
                                                                      "labels.involveInScheduling"
                                                                    )
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "labels.involveInScheduling"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.selectedJobType
                                                          .partakeInScheduling,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobType,
                                                          "partakeInScheduling",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobType.partakeInScheduling"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("v-switch", {
                                                    staticClass:
                                                      "pt-0 mt-1 d-inline-block",
                                                    attrs: {
                                                      color: "success",
                                                      dense: "",
                                                      disabled: !_vm
                                                        .selectedJobType
                                                        .partakeInScheduling,
                                                      "hide-details": "",
                                                      inset: ""
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.onIsChargeNurseChange
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function() {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "mr-4 body-2 grey--text text--darken-3",
                                                                  attrs: {
                                                                    title: _vm.$t(
                                                                      "labels.isChargeNurse"
                                                                    )
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "labels.isChargeNurse"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.selectedJobType
                                                          .settings
                                                          .isChargeNurse,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobType
                                                            .settings,
                                                          "isChargeNurse",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobType.settings.isChargeNurse"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("v-switch", {
                                                    staticClass:
                                                      "pt-0 mt-1 d-inline-block",
                                                    attrs: {
                                                      color: "success",
                                                      dense: "",
                                                      disabled:
                                                        !_vm.selectedJobType
                                                          .partakeInScheduling ||
                                                        _vm.selectedJobType
                                                          .settings
                                                          .isChargeNurse,
                                                      "hide-details": "",
                                                      inset: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function() {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "mr-4 body-2 grey--text text--darken-3",
                                                                  attrs: {
                                                                    title: _vm.$t(
                                                                      "labels.canBeChargeNurse"
                                                                    )
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "labels.canBeChargeNurse"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.selectedJobType
                                                          .settings
                                                          .canBeChargeNurse,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobType
                                                            .settings,
                                                          "canBeChargeNurse",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobType.settings.canBeChargeNurse"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("v-divider"),
                                      _c(
                                        "v-row",
                                        { attrs: { dense: "" } },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "text-right pb-0 pt-4 px-8",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mr-4",
                                                  attrs: {
                                                    disabled: _vm.saving,
                                                    text: ""
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.closeJobTypeDialog
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t("labels.cancel")
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _vm.selectedJobType.id
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "submit",
                                                      attrs: {
                                                        color: "secondary",
                                                        disabled:
                                                          invalid || _vm.saving
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return passes(
                                                            _vm.update
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.saving
                                                        ? _c(
                                                            "v-progress-circular",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary lighten-2",
                                                                indeterminate:
                                                                  "",
                                                                size: "22",
                                                                width: "2"
                                                              }
                                                            }
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "labels.save"
                                                                  )
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ])
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "submit",
                                                      attrs: {
                                                        color: "secondary",
                                                        disabled:
                                                          invalid || _vm.saving
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return passes(_vm.add)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.saving
                                                        ? _c(
                                                            "v-progress-circular",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary lighten-2",
                                                                indeterminate:
                                                                  "",
                                                                size: "22",
                                                                width: "2"
                                                              }
                                                            }
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "labels.add"
                                                                  )
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ])
                                                    ],
                                                    1
                                                  )
                                            ],
                                            1
                                          ),
                                          _c("v-spacer")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1399619460
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.deleteDialog.show
        ? _c("DeleteConfirmation", {
            attrs: {
              action: "org/checkJobTypeDependencies",
              "delete-body": _vm.$t("descriptions.continueDeleteJobType", {
                name: _vm.deleteDialog.jobType.name
              }),
              "dependencies-body": _vm.$t(
                "descriptions.hasDependenciesJobType",
                { name: _vm.deleteDialog.jobType.name }
              ),
              item: _vm.deleteDialog.jobType,
              title: _vm.$t("labels.deleteJobType?")
            },
            on: {
              close: _vm.closeDeleteConfirmationDialog,
              del: _vm.deleteJobType
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }